import Vue from 'vue';

// When the request succeeds
const success = (context, response) => {
  toastr.success(context.$t("billing_modal.subscription_active_success"));
  setTimeout(() => window.location.reload(), 3000);
};

// When the request fails
const failed = (context, response) => {
  // toastr.error(context.$t("billing_modal.subscription_active_fail"));
  // if (response.msg === 'action_required') {
  //   console.log(response.payment_intent);
  //   context.paymentIntent = response.payment_intent;
  // }
  toastr.error(response.msg);
};

export default (context, planId, rentalId) => Vue.$http.post('/activate-subscription', { planId, rentalId })
  .then((response) => {
    if (response && response.status === 200) {
      success(context, response.data);
    } else {
      failed(context, response.data);
    }
  })
  .catch((error) => {
    failed(context, error.response.data);
  });



// WEBPACK FOOTER //
// ./src/app/services/subscription/activateSubscription.js